import axiosInstance from 'plugins/axios';
import { IBodyResponse } from 'types/type.global';
import {
    ILoginForm,
    IRegisterForm,
    IResgisterResponse,
    ILoginResponse,
    IResetPasswordForm,
    ILoginThirdPartyForm,
} from 'types/auth';

export const signIn = async (
    user: ILoginForm
): Promise<IBodyResponse<ILoginResponse>> => {
    const response = await axiosInstance.post('admin/sign_in', user);
    return response.data;
};

export const signOut = async (): Promise<IBodyResponse<null>> => {
    const response = await axiosInstance.delete('admin/sign_out');
    if (!response.data.success) {
        throw new Error(response.data.message || '');
    }
    return response.data;
};

export const signUp = async (
    user: IRegisterForm
): Promise<IBodyResponse<IResgisterResponse>> => {
    const response = await axiosInstance.post('admin/sign_up', user);
    return response.data;
};

export const forgotPassword = async (data: {
    email: string;
}): Promise<IBodyResponse<object>> => {
    const response = await axiosInstance.post('admin/passwords', data);
    return response.data;
};

export const verifyEmail = async (email: string) => {
    const response = await axiosInstance.get(
        `admin/admins/verify_email?email=${email}`
    );
    return response.data;
};

export const resetPassword = async (
    token: string,
    data: IResetPasswordForm
): Promise<IBodyResponse<IResgisterResponse>> => {
    const response = await axiosInstance.put(`admin/passwords/${token}`, data);
    return response.data;
};

export const resendEmailConfirmation = async (
    email: string
): Promise<IBodyResponse<null>> => {
    const response = await axiosInstance.post(
        'admin/admins/resend_email_confirmation',
        {
            email,
        }
    );
    return response.data;
};

export const confirmEmail = async (
    token: string
): Promise<IBodyResponse<null>> => {
    const response = await axiosInstance.get(`admin/confirm_email/${token}`);
    return response.data;
};

export const loginWithThirdParty = async (
    user: ILoginThirdPartyForm
): Promise<IBodyResponse<ILoginResponse>> => {
    const response = await axiosInstance.post('admin/oauth_sign_in', user);
    return response.data;
};
